<script>
	let watt = 375;
	
	let hours_per_day = 6;
	let days_per_week = 5;
	let kwh_price_cent = 27;
	
	let plus80 = [
		{'name': 'White', 'efficiency': .85},
		{'name': 'Bronze', 'efficiency' : .88},
		{'name': 'Silver', 'efficiency' : .90},
		{'name': 'Gold', 'efficiency' : .92},
		{'name': 'Platinum', 'efficiency' : .94},
		{'name': 'Titanium', 'efficiency' : .96},
		];
</script>

<h1>
	80 Plus PSU energy cost calculator
</h1>

<p>
	This calculator helps you to decide if you save money by getting a more expensive power supply, because it's more efficient. Additionally it tells you how much your computer will probably cost you per year in electrical power.	
</p>
<p><a href="https://www.reddit.com/r/buildapc/comments/rn20ox/i_made_a_tool_to_calculate_how_much_money_you/">Discussion on /r/buildapc</a></p>
<p>
	<small>The calculator simpliefies a lot of things and your real world numbers will probably be off. The calculator assumes that your computer constantly uses exactly 50% of what the PSU is rated for. If you enter 250 Watt, it assumes you use a 500 Watt rated PSU. If it uses more or less, the PSU becomes less efficient. It uses 80 Plus ratings for 230 V internal non-redundant PSUs.</small>
</p>

<label>
	Watt: How much power do your components use on average<br>
	<input type=number bind:value={watt} min=50 max=1500>
	<input type=range bind:value={watt} min=50 max=1500><br>
</label>
<label>
	Days per week: On how many days do you use your computer<br>
	<input type=number bind:value={days_per_week} min=1 max=7>
	<input type=range bind:value={days_per_week} min=1 max=7><br>
</label>
<label>
	Hours per day: How long do you use your computer on those days<br>
	<input type=number bind:value={hours_per_day} min=1 max=24>
	<input type=range bind:value={hours_per_day} min=1 max=24><br>
</label>
<label>
	kWh price in Cents: How much do you pay for power<br>
	<input type=number bind:value={kwh_price_cent} min=1 max=100>
	<input type=range bind:value={kwh_price_cent} min=1 max=100><br>
</label>

<table>
	<tr>
		<th>80 Plus</th>
		<th>Draw from Wall (W)</th>
		<th>kWh per year</th>
		<th>Cost per year</th>
		<th>Savings after 5 years (to 1 tier lower)</th>
		<th>Savings after 5 years to 80 Plus White</th>
	</tr>
	{#each plus80 as tier, i}
		<tr>
			<td>{tier['name']} ({tier['efficiency']*100}%)</td>
			<td>{(watt/tier['efficiency']).toFixed(2)}</td>
			<td>{(watt*hours_per_day*days_per_week*52/tier['efficiency']/1000).toFixed(2)}</td>
			<td>{((watt*hours_per_day*days_per_week*52/1000/tier['efficiency']*kwh_price_cent)/100).toFixed(2)}</td>
			{#if i > 0}
			<td>{(((watt*hours_per_day*days_per_week*52/1000/plus80[i-1]['efficiency']*kwh_price_cent)-(watt*hours_per_day*days_per_week*52/1000/tier['efficiency']*kwh_price_cent))/100*5).toFixed(2)}</td>
			{/if}
			{#if i > 0}
			<td>{(((watt*hours_per_day*days_per_week*52/1000/plus80[0]['efficiency']*kwh_price_cent)-(watt*hours_per_day*days_per_week*52/1000/tier['efficiency']*kwh_price_cent))/100*5).toFixed(2)}</td>
			{/if}
		</tr>
	{/each}
</table>

<small>Savings are shown in 100 Cents. If you enter your energy costs as Euro Cents, the savings will be in Euros. If you enter them in US Dollar Cents, the savings will be in US Dollars. If you enter them in another currency, they will be in that currency, as long as 100 Cents (or whatever it is called) is 1 Currency.</small>

<p><small>If you like this tool, <a href="https://twitter.com/luca">follow me on Twitter</a>.</small></p>
